import clsx from 'clsx';
import { Typography } from '@ag1/ui';
import { useTranslation } from 'react-i18next';
import styles from './OfferPrice.module.scss';
import { PricingConfig } from '../types';
import { CoreProductRow } from './CoreProductRow';
import { AddonProductRow } from './AddonProductRow';

interface Props {
  pricingConfig: PricingConfig;
  showOldPriceFirst: boolean;
}

export const OfferPriceTable = ({
  pricingConfig: {
    coreProduct,
    coreProducts,
    addonProducts,
    total,
    rawTotal,
    discountedTotal,
    rawDiscountedTotal
  },
  showOldPriceFirst
}: Props) => {
  const { t } = useTranslation('offer');

  if (!coreProduct && !coreProducts) return null;

  return (
    <div className={styles.table}>
      {/* Core Products */}
      {(coreProduct || Boolean(coreProducts?.length)) && (
        <div className={clsx(styles.tableSection, styles.top)}>
          {coreProduct && (
            <CoreProductRow coreProduct={coreProduct} showOldPriceFirst={showOldPriceFirst} />
          )}
          {coreProducts &&
            coreProducts.map((product, index) => (
              <CoreProductRow
                key={`core-product-${product.shopifyVariantId}-${index + 1}`}
                coreProduct={product}
                showOldPriceFirst={showOldPriceFirst}
              />
            ))}
        </div>
      )}

      {/* Addon Products */}
      {addonProducts.length > 0 && (
        <div className={clsx(styles.tableSection, styles.top)}>
          <Typography
            color="black-new"
            variant="captionMono"
            size="1"
            className={styles.tableItemsHeadline}>
            {t('offerPrice.firstTimePurchaseIncludes')}
          </Typography>
          {addonProducts.map(
            (row, index) =>
              row.name && (
                <AddonProductRow
                  key={`addon-product-${row.shopifyVariantId}-${index + 1}`}
                  addonProduct={row}
                  showOldPriceFirst={showOldPriceFirst}
                />
              )
          )}
        </div>
      )}

      {/* Total row */}
      <div className={styles.tableRow}>
        <Typography
          color="black-new"
          variant="body"
          size="2"
          weight="700"
          noPadding
          className={styles.tableHeadline}>
          {t('offerPrice.total')}
        </Typography>
        <div className={clsx(styles.tablePrice, showOldPriceFirst && styles.flexRowReverse)}>
          {rawTotal > rawDiscountedTotal ? (
            <>
              <Typography
                color="black-new"
                variant="body"
                size="2"
                noPadding
                className={styles.tablePriceBasic}>
                <s>{total}</s>
              </Typography>
              <Typography
                color="black-new"
                variant="body"
                size="2"
                weight="700"
                noPadding
                className={styles.tablePriceAlt}>
                {discountedTotal}
              </Typography>
            </>
          ) : (
            <Typography
              color="black-new"
              variant="body"
              size="2"
              weight="700"
              noPadding
              className={styles.tablePriceAlt}>
              {total}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};
